import { PremiumBreakdown, smBumps } from '@wrisk/ui-components'
import React, { FC } from 'react'

import { IPT } from '../../product'
import { useStandardAdjustedPremium } from './hooks'
import {
  StandardAdjustedPremium,
  StandardAdjustedPremiumProps,
} from './StandardAdjustedPremium'

export const StandardAdjustedPremiumTerm: FC<StandardAdjustedPremiumProps> = (props) => {
  const { currentPremiums, previousPremiums, promotion, tKey } = props

  const { lineItems, additionalItems, extraInfo } = useStandardAdjustedPremium({
    currentPremiums,
    previousPremiums,
    promotion,
    tKey,
  })

  return (
    <StandardAdjustedPremium {...props}>
      <PremiumBreakdown
        extraInfo={extraInfo}
        lineItems={lineItems}
        additionalLineItems={additionalItems}
        ipt={<IPT amount={currentPremiums.totals.taxAmount} />}
        mx={smBumps}
      />
    </StandardAdjustedPremium>
  )
}
